import { useAutomationStep } from "../../automations/hooks/useAutomationStep";
import { useMemo } from "react";
import { WorkflowStepTypes } from "../../flows/stepTypes";
import { CircularLoader, Title } from "@introist/react-foundation/v2";

export const AutomationStepViewer = ({ stepId }: { stepId: string }) => {
  const { step } = useAutomationStep({ id: stepId });

  const stepDef = useMemo(() => {
    if (step === undefined) return undefined;
    return WorkflowStepTypes.find(s => s.stepType === step.stepType) ?? null;
  }, [step]);

  if (stepDef === undefined) return <CircularLoader fillParent />;

  if (stepDef === null || !stepDef.Viewer) {
    return <Title>Nothing to show for this step type</Title>;
  }

  return <stepDef.Viewer stepId={stepId} step={step!} />;
};
